// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UfCZ","top":"styles_top__1IagG","left":"styles_left__23sDc","description":"styles_description__1NXT4"};